import React from "react";
import { useEffect } from "react";
import { SolicitudAusenciaService } from "services";
import { ApiResponse } from "enum";
import { useAtom } from "jotai";
import { solicitudesAusenciaHistoricoAtom } from "../HistoricoSolicitudesStore";

// habilitado=false evita cargar el histórico completo cuando la pantalla consulta por servidor (filtros + paginación).
const useListarSolicitudesAusenciaPorJefeInmediato = (habilitado = true) => {
    const [solicitudesAusenciaHistorico, setSolicitudesAusenciaHistorico] = useAtom(solicitudesAusenciaHistoricoAtom);
    
	useEffect(() => {
		if (!habilitado) {
			return;
		}
		const cargarDatos = async () => {
			const solicitudesAusenciaHistorico = await SolicitudAusenciaService.listarHistoricoPorJefeInmediato();
			if (solicitudesAusenciaHistorico.estado === ApiResponse.EXITO) {
				setSolicitudesAusenciaHistorico(solicitudesAusenciaHistorico.data);				
			}
		};
		cargarDatos();
	}, []);
	return { solicitudesAusenciaHistorico};
    
}
export default useListarSolicitudesAusenciaPorJefeInmediato;